import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main-layout-container" }
const _hoisted_2 = { class: "sys-header" }
const _hoisted_3 = { class: "sys-header__info" }
const _hoisted_4 = { class: "sys-header__info--notify cursor-pointer" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = {
  key: 0,
  class: "label"
}
const _hoisted_7 = { class: "sys-header__info--cydas-logo cursor-default" }
const _hoisted_8 = { class: "sys-header__info--divide" }
const _hoisted_9 = { class: "sys-header__info--user" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "popup-profile absolute" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "top-bot" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "top-bot top-bot-border" }, null, -1)
const _hoisted_14 = { class: "sys-container" }
const _hoisted_15 = { class: "nav-content flex" }
const _hoisted_16 = { class: "nav-content-menu" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "divider-gray w-8" }, null, -1)
const _hoisted_18 = { class: "nav-content-sub-menu" }
const _hoisted_19 = { class: "font-bold mb-3 pl-4 pr-3" }
const _hoisted_20 = { class: "mr-2" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SysLogo = _resolveComponent("SysLogo")
  const _component_NotificationIcon = _resolveComponent("NotificationIcon")
  const _component_CydasLogo = _resolveComponent("CydasLogo")
  const _component_LineIcon = _resolveComponent("LineIcon")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_BaseIcon = _resolveComponent("BaseIcon")
  const _component_RectangleLastIcon = _resolveComponent("RectangleLastIcon")
  const _component_RectangleIcon = _resolveComponent("RectangleIcon")
  const _component_router_view = _resolveComponent("router-view")
  const _component_ToastApp = _resolveComponent("ToastApp")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sys-header__logo",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.nameCompany)))
      }, [
        _createVNode(_component_SysLogo, { class: "cursor-pointer" })
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_NotificationIcon)
          ]),
          (_ctx.notifyNumber)
            ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.notifyNumber > 99 ? '99+' : _ctx.notifyNumber), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_CydasLogo)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_LineIcon)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, _toDisplayString(_ctx.userInfo.employee_name), 1),
          (_ctx.userInfo.url)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                class: "avatar cursor-pointer",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleTogglePopupProfile && _ctx.handleTogglePopupProfile(...args)))
              }))
            : (_openBlock(), _createBlock("div", {
                key: 1,
                class: "default-avatar cursor-pointer",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleTogglePopupProfile && _ctx.handleTogglePopupProfile(...args)))
              }, [
                _createVNode(_component_Avatar, {
                  id: _ctx.userInfo.pp_employee_id,
                  name: 
                _ctx.nameAvatar[0]?.profileFile ? '' : _ctx.nameAvatar[0]?.nameFaceImage
              ,
                  src: _ctx.nameAvatar[0]?.profileFile
                }, null, 8, ["id", "name", "src"])
              ]))
        ]),
        _withDirectives(_createVNode("div", {
          onClick: [
            _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
            _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleHiddenPopupProfile && _ctx.handleHiddenPopupProfile(...args)))
          ],
          class: "fixed top-0 left-0 w-screen h-screen z-50 cursor-default"
        }, null, 512), [
          [_vShow, _ctx.isShowPopupProfile]
        ]),
        _withDirectives(_createVNode("ul", _hoisted_11, [
          _hoisted_12,
          _hoisted_13,
          _createVNode("li", {
            onClick: [
              _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
              _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
            ],
            class: "dialog-content cursor-pointer p-2 z-50"
          }, _toDisplayString(_ctx.t('logout')), 1)
        ], 512), [
          [_vShow, _ctx.isShowPopupProfile]
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _createVNode("ul", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navMenu, (item) => {
              return (_openBlock(), _createBlock("li", {
                key: item.icon,
                class: ["nav-content-menu--item flex justify-center cursor-pointer items-center", 
                _ctx.chooseMenu === item.value ? 'nav-content-menu--active' : ''
              ],
                onClick: ($event: any) => (_ctx.onClickMenuItem(item))
              }, [
                _createVNode(_component_BaseIcon, {
                  name: item.icon
                }, null, 8, ["name"])
              ], 10, ["onClick"]))
            }), 128))
          ]),
          _hoisted_17,
          _withDirectives(_createVNode("span", {
            class: ["font-size-24 cursor-pointer navbar-expand", 
              _ctx.isExpandMenu
                ? 'cp-icon-arrow-circle-left'
                : 'cp-icon-arrow-circle-right'
            ],
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isExpandMenu = !_ctx.isExpandMenu))
          }, null, 2), [
            [_vShow, _ctx.chooseMenu !== 0]
          ])
        ]),
        _withDirectives(_createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, _toDisplayString(_ctx.navSubMenu[_ctx.chooseMenu]?.title), 1),
          _createVNode("ul", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navSubMenu[_ctx.chooseMenu]?.content, (item) => {
              return (_openBlock(), _createBlock("li", {
                key: item.text,
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.goToPage(item))
              }, [
                _createVNode("div", {
                  class: ["flex nav-content-submenu--item", 
                  _ctx.isActiveNavMenu(item) ? 'nav-content-submenu--active' : ''
                ],
                  onClick: ($event: any) => (_ctx.isShowSubmenu[item.text] = !_ctx.isShowSubmenu[item.text])
                }, [
                  _createVNode("div", _hoisted_20, [
                    _createVNode(_component_BaseIcon, {
                      name: item.icon
                    }, null, 8, ["name"])
                  ]),
                  _createVNode("div", null, _toDisplayString(item.text), 1)
                ], 10, ["onClick"]),
                (item.child && _ctx.isShowSubmenu[item.text])
                  ? (_openBlock(), _createBlock("ul", _hoisted_21, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.child, (subItem, subItemIndex) => {
                        return (_openBlock(), _createBlock("li", {
                          key: subItem.text,
                          class: ["nav-content-submenu--item", 
                    _ctx.isActiveNavSubMenu(subItem.path)
                      ? 'nav-content-submenu--active'
                      : ''
                  ],
                          onClick: _withModifiers(($event: any) => (_ctx.goToPage(subItem)), ["stop"])
                        }, [
                          _createVNode("div", _hoisted_22, [
                            (subItemIndex === item.child.length - 1)
                              ? (_openBlock(), _createBlock(_component_RectangleLastIcon, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_RectangleIcon, { key: 1 }))
                          ]),
                          _createVNode("div", null, _toDisplayString(subItem.text), 1)
                        ], 10, ["onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 8, ["onClick"]))
            }), 128))
          ])
        ], 512), [
          [_vShow, _ctx.isExpandMenu && _ctx.chooseMenu !== 0]
        ])
      ]),
      _createVNode("div", {
        class: ["main-content", !_ctx.isExpandMenu || _ctx.chooseMenu === 0 ? 'main-content-submenu' : '']
      }, [
        _createVNode(_component_router_view)
      ], 2)
    ]),
    _createVNode(_component_ToastApp)
  ]))
}